import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleInvoicePaidInvoicesPageTourConfig: AgTechTourConfig = {
    id: 'sale-invoicing-paid-page-tour',
    name: 'Paid Invoices Tour',
    steps: [
        {
            targetId: 'sale-invoicing-paid-grid',
            title: 'Paid Invoices Grid',
            description: 'A record of all fully paid invoices for this sale. Click an invoice number to view its details and payment history.',
            position: 'right',
        },
        {
            targetId: 'sale-invoicing-paid-count-metric',
            title: 'Paid Invoices',
            description: 'Total number of invoices that have been fully paid.',
            position: 'left',
        },
        {
            targetId: 'sale-invoicing-paid-total-metric',
            title: 'Total Paid',
            description: 'The combined amount collected across all paid invoices for this sale.',
            position: 'left',
        },
    ]
}
